import React from "react";
import { PageTitle } from "../../../../_metronic/layout/core";
import GenericReport from "../GenericReport";

const WaterWashAnalysisPage: React.FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[{ title: "Reports", path: "/reports", isActive: false }]}>
        Water Wash Analysis
      </PageTitle>
      <GenericReport reportId={13} />
    </>
  );
};

export default WaterWashAnalysisPage;
